import ajax from '@/resources/myApi';
import vm from '@/main';

const service = {
  getLookupTables,
  getLookupTableValues,
  manageLookupTableValue,
  deleteLookupValue
};

async function getLookupTables() {
  const params = {
    pageNumber: 0,
    pageSize: 1,
    filters: { isFixed: false },
  };
  try {
    const { data } = await ajax.get('api/LookupTable/', {
      name: 'LookupTable',
      params,
    });

    return data.items;
  } catch (error) {
    console.log('API Catch:',error.message);
    return { items: [], paging: {} };
  }
}

async function getLookupTableValues(id) {
  try {
    const { data } = await ajax.get(`api/LookupTable/${id}/Values`, {
      name: 'LookupTable',
    });
    return data;
  } catch (error) {
    if (error.response && error.response.status < 500) {
      vm.$snotify.error('LookupTable not found');
    }
    return [];
  }
}

async function manageLookupTableValue(dto) {
  try {
    if (dto.id) {
      var { data } = await ajax.put(`api/LookupTable/${dto.lookupTableId}/Value/${dto.id}`, {
        name: 'LookupTable',
        body: dto,
      });
    } else {
      var { data } = await ajax.post(`api/LookupTable/${dto.lookupTableId}/Value`, {
        name: 'LookupTable',
        body: dto,
      });
    }

    if (data.id) {
      vm.$snotify.success((dto.id) ? 'LookupTable value saved' : 'LookupTable value has been created', 'LookupTable');
      return data.id;
    }
  } catch (error) {
    console.log('API Catch:',error.message);
    return {}
  }
}

async function deleteLookupValue(lookupTableId, id) {
  try {
    return await ajax.delete(`api/LookupTable/${lookupTableId}/Value/${id}`, {
      name: 'Delete Lookup Value'
    });
  } catch {}
}

export default service;
